import styled from 'styled-components';

export const SkillListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #333;
  margin: 40px 0 0 0;

  @media (max-width: 480px) {
    margin: 20px 0;
  }
`;

export const SkillItem = styled.div`
  width: 33%;
  margin-bottom: 60px;
  text-align: center;

  @media (max-width: 767px) {
    width:48%;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

export const SkillItemContent = styled.div`
  max-width: 350px;
  margin: 0 auto;

  h3 {
    font-size: 1.4em;
    margin: 0 0 0.25em 0;
  }

  @media (max-width: 992px) {

    padding:0 5px;

    p {
      font-size: 1em;
    }

    h3 {
      font-size: 1.1em;
    }

  }

  @media (max-width: 480px) {

    p {
      font-size: 0.9em;
    }

    h3 {
      font-size: 1em;
    }

  }
`;

export const SkillItemIcon = styled.div`
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/digitalNomad/SkillList.style.js